import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosGet } from "utils/APIHelper";
import { PAGE_SIZE } from "utils/CommonConstants";
import { responseTypes, serviceTypes } from "utils/Types";

const initialState: any = {
  progressLoader: false,
  progressInfo: {
    summaryDetail: {},
    userHtlids: [],
    allUsers: {},
    plan: { tableDetails: [], totalRecords: 0 },
    property: { tableDetails: [], totalRecords: 0 },
    users: { tableDetails: [], totalRecords: 0 }
  }
};
function isRejectedAction(action: any) {
  return action.type.endsWith("rejected");
}

export const fetchProgressTableInfoAsync = createAsyncThunk("progress_table_info", async (data: any, thunkApi: any) => {
  const API_URL = `inncode-groups/${data?.id}?view=plans&page=${data.page || 0}&size=${PAGE_SIZE}&${data.payloadUrl}`;
  const response: any = await axiosGet(API_URL, serviceTypes.userplan, {});
  if (response?.response?.status >= responseTypes.error) {
    return thunkApi.rejectWithValue(response.response);
  }

  return { type: data.type, res: response.data };
});
export const fetchAssigneeDetailsProgressAsync = createAsyncThunk(
  "associates_users",
  async (data: any, thunkApi: any) => {
    const API_URL = `associates?size=${data.size}&hltIds=${data.value}`;

    const response: any = await axiosGet(API_URL, serviceTypes.user);
    if (response?.response?.status >= responseTypes.error) {
      return thunkApi.rejectWithValue(response.response);
    }

    return response.data;
  }
);

export const ProgressSlice = createSlice({
  name: "Progress_Slice",
  initialState,
  reducers: {
    setProgressInfoSummary: (state, action) => {
      state.progressInfo.summaryDetail = action.payload;
    },
    setProgressLoader: (state, action) => {
      state.progressLoader = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchProgressTableInfoAsync.pending, (state, action: any) => {
        state.progressLoader = action.meta.arg.page === 0;
      })
      .addCase(fetchProgressTableInfoAsync.fulfilled, (state, action: any) => {
        const type = action.payload.type;
        state.progressInfo[type].tableDetails =
          action.meta.arg.page === 0
            ? action.payload?.res.mappings
            : [...state.progressInfo[type].tableDetails, ...action.payload?.res.mappings];
        state.progressInfo[type].totalRecords = action.payload?.res.meta.page.total;
        state.progressInfo.userHtlids = action.payload?.res.meta.mappedUsers;
        state.progressInfo.userInncodes = action.payload?.res.meta.mappedInnCodes;
      })
      .addCase(fetchAssigneeDetailsProgressAsync.pending, (state, action: any) => {})
      .addCase(fetchAssigneeDetailsProgressAsync.fulfilled, (state, action: any) => {
        state.progressInfo.allUsers = action.payload;
        state.progressLoader = false;
      })
      .addMatcher(isRejectedAction, (state, action) => {
        state.progressLoader = false;
      });
  }
});
export const { setProgressInfoSummary, setProgressLoader } = ProgressSlice.actions;
export default ProgressSlice.reducer;
